
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Inject, Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Observable, of } from "rxjs";
import { concatMap } from "rxjs/operators";

import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { AccountInfo } from '@azure/msal-common';
import { BaseMsalGuard } from './base-msal.guard';



interface Account extends AccountInfo {
  idTokenClaims?: {
    roles?: string[]
  }
}

@Injectable({
  providedIn: 'root'
})
export class AdminGuard extends BaseMsalGuard {
  constructor(
    @Inject(MSAL_GUARD_CONFIG) protected override msalGuardConfig: MsalGuardConfiguration,
    protected override msalBroadcastService: MsalBroadcastService,
    protected override authService: MsalService,
    protected override location: Location,
    protected override router: Router
  ) {
    super(msalGuardConfig, msalBroadcastService, authService, location, router);
  }
  override activateHelper(state?: RouterStateSnapshot, route?: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    let result = super.activateHelper(state, route);

    return result.pipe(
      concatMap(() => {
        let activeAccount = this.authService.instance.getActiveAccount();
        if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
          activeAccount = this.authService.instance.getAllAccounts()[0];
        }

        const roles: string[] = activeAccount?.idTokenClaims?.roles || [];

        if (!roles || roles.length === 0) {
          window.alert('El token no contiene el claim de roles. Asegúrate de que tu cuenta tiene asignado un rol y vuelve a iniciar sesión.');
          return of(false);
        }

     

        return of(true); // Solo devuelve true si tiene el rol de superadmin
      })
    );
  }

}
